import { render, staticRenderFns } from "./SiteAppsAppInstalled.vue?vue&type=template&id=1f8aef7f&scoped=true&"
import script from "./SiteAppsAppInstalled.vue?vue&type=script&lang=js&"
export * from "./SiteAppsAppInstalled.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppsAppInstalled.vue?vue&type=style&index=0&id=1f8aef7f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8aef7f",
  null
  
)

export default component.exports